module.exports = __webpack_public_path__ + "static/media/generic_icon.1c8d1bd1.svg";